import { consultationStatus, useConsultation } from '@entities/consultations';
import cn from 'classnames';
import type React from 'react';

import { Messenger } from '@shared/assets';
import { useMobile, useUser } from '@shared/hooks';

import { statusText } from './lib';
import * as st from './styles.module.scss';

type Props = {
	id: number;
	onClick?: () => void;
};

export const ConsultationStatus: React.FC<Props> = ({ id, onClick }) => {
	const { consultation } = useConsultation(id);
	const { user } = useUser();

	const status = consultationStatus(consultation);
	const { isMobile } = useMobile();

	const showButton =
		status === 'notPayed' || status === 'unconfirmed' || status === 'awaitingPayment';
	const btnText = user?.is_coach ? 'Оповестить' : 'Оплатить';

	return (
		<div className={st.status}>
			<div className={cn(st.status__text, st[status])}>{statusText[status]}</div>
			{showButton && (
				<button className={st.status__btn} onClick={onClick}>
					{isMobile ? <Messenger /> : btnText}
				</button>
			)}
		</div>
	);
};
